export enum tabsNamesKeys {
  passport = "passport",
  phone = "phone",
  email = "email",
  confirmCode = "confirmCode",
  password = "password",
  exit = "exit",
}
